export default __webpack_public_path__ + "static/media/USDT-white.a8477c3b.svg";